'use es6';

/***
 * render legend on the bottom
 *
 * ONLY used for reporting visual exports
 */
export const applyOnlyLegend = (visualization, report) => report.getIn(['displayParams', 'onlyLegend'], false) ? visualization.setIn(['style', 'bottomLegend'], true).setIn(['style', 'height'], 600) : visualization;